var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.572 5.643c-1.197-2.595-4.193-4.393-7.388-4.393h-0.098c-4.492 0-8.088 2.795-8.088 6.29 0.020 1.338 0.507 2.558 1.305 3.509l-0.007-0.009-0.698 3.5 4.4-1.11c0.894 0.314 1.925 0.497 2.999 0.5h0.001c2.695 0 5.090-1 6.5-2.595 1.572-1.8 1.873-3.795 1.072-5.692z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }